// noinspection JSUnusedGlobalSymbols

import { MODE } from '../config';
import { logger } from '../screens/Services/Debug/logger';
import { createReducerFor } from './utils';

const TYPE = 'LOGS';
export const LOG_TO_RELEASE = false;

const initialState = { items: {} };

export const addLog = (section, data) => (dispatch, getState) => {
    if (MODE !== 'qa' && !LOG_TO_RELEASE) {
        return;
    }
    logger.log(section, data);
    const currentData = getState()?.log?.items;
    const currentInSection = currentData?.[section] ?? [];
    dispatch({
        type: TYPE,
        payload: {
            items: {
                ...currentData,
                [section]: [ ...currentInSection, data ],
            },
        },
    });
};

export const clearSection = (section) => (dispatch) =>
    dispatch({
        type: TYPE,
        payload: { items: { [section]: [] } },
    });

export const clearLog = () => (dispatch) => {
    const payload = { items: {} };
    logger.clear();
    dispatch({
        type: TYPE,
        payload,
    });
};

export default createReducerFor(TYPE, initialState);
